import React from "react";
import PropTypes from "prop-types";
import EventListener from "react-event-listener";
import { Row, Col } from "react-flexbox-grid/lib/index";
import ContainerDimensions from "react-container-dimensions";
import { Typography } from "@material-ui/core";
import { camelCase, startCase } from "lodash";
import RequireWorkarea from "components/RequireWorkarea";
import RequireOrganization from "components/RequireOrganization";
import { soloNotSupported } from "util/solo";
import FileDropCard from "./FileDropCard";
import FileListCard from "./FileListCard";

const UploadLayout = props =>
  soloNotSupported(props.workarea, props.organization) ? (
    <Typography variant="h6" style={{ textAlign: "center" }}>
      Solo tools are not supported for the combination of{" "}
      {startCase(camelCase(props.organization))} organization and{" "}
      {startCase(camelCase(props.workarea))} workarea.
    </Typography>
  ) : (
    <RequireOrganization {...props}>
      <RequireWorkarea {...props}>
        {/* Prevent default window action on drag and drop file */}
        <EventListener
          target={window}
          ondrop={e => {
            e.preventDefault();
          }}
        />
        <EventListener
          target={window}
          ondragover={e => {
            e.preventDefault();
          }}
        />

        <Row>
          <Col xs={12} sm={11} md={10} lg={6}>
            <FileDropCard {...props} />
          </Col>

          <Col xs={12} sm={11} md={10} lg={6}>
            <ContainerDimensions>
              <FileListCard {...props} />
            </ContainerDimensions>
          </Col>
        </Row>
      </RequireWorkarea>
    </RequireOrganization>
  );

UploadLayout.propTypes = {
  workarea: PropTypes.string,
  organization: PropTypes.string
};
UploadLayout.defaultProps = {
  workarea: null,
  organization: null
};
export default UploadLayout;
